export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function rectRight(rect: Rect): number {
  return rect.x + rect.width;
}

export function rectBottom(rect: Rect): number {
  return rect.y + rect.height;
}

export function rectsEqual(left: Rect | undefined, right: Rect | undefined): boolean {
  if (!left || !right) {
    return left === right;
  }

  return (
    left.x === right.x &&
    left.y === right.y &&
    left.width === right.width &&
    left.height === right.height
  );
}

export function unionRects(rects: Rect[]): Rect | null {
  if (rects.length === 0) {
    return null;
  }

  let minX = rects[0]!.x;
  let minY = rects[0]!.y;
  let maxX = rectRight(rects[0]!);
  let maxY = rectBottom(rects[0]!);

  for (const rect of rects.slice(1)) {
    minX = Math.min(minX, rect.x);
    minY = Math.min(minY, rect.y);
    maxX = Math.max(maxX, rectRight(rect));
    maxY = Math.max(maxY, rectBottom(rect));
  }

  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}
